import { render, staticRenderFns } from "./OrderDetailsAddress.vue?vue&type=template&id=0a328d94&"
import script from "./OrderDetailsAddress.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailsAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports